import { useContext } from "react"
import Text from "lib/components/Text"
import MarkdownReader from "lib/components/Markdown/reader"
import { LanguageContext } from "context/LanguageContext"

export default function Summary({ program_detail }) {
  const { useTranslation: t } = useContext(LanguageContext)
  return (
    <div className="mt-10">
      <Text size="large" color="dark" weight="semibold">
        {t("program_summary")}
      </Text>
      <MarkdownReader>{program_detail?.summary}</MarkdownReader>
    </div>
  )
}
